import React from 'react';
import { PropTypes } from 'prop-types';
import styles from '../styles.css';

const Breadcrumbs = props => <ul className={styles.breadcrumbs}>{props.crumbs}</ul>;

Breadcrumbs.propTypes = {
	crumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Breadcrumbs;
